/**
 * Dashboard
 */
export const DASHBOARD = 'dashboard';

/**
 * Login/Logout
 */
export const LOGIN = 'Login';
export const LOGOUT = 'Logout';

/**
 * Register
 */
export const REGISTER = 'Register';
export const REGISTER_COMPLETE = 'RegisterComplete';

/**
 * Password
 */
export const RESET_PASSWORD = 'ResetPassword';
export const CHANGE_PASSWORD = 'change-password';

/**
 * Settings
 */
export const SETTINGS_COMPANY = 'company-settings';
export const SETTINGS_USER = 'user-settings';

/**
 * Support
 */
export const FAQ = 'faq';

/**
 * Templates
 */
export const TEMPLATE_CATEGORIES = 'categories';
export const TEMPLATE_CATEGORY_DESIGNS = 'category-designs';

/**
 * Personalize
 */
export const PERSONALIZE = 'personalize';
export const PERSONALIZE_DESIGN = 'personalize-design';

/**
 * Projects
 */
export const PROJECTS = 'projects';

/**
 * Widgets
 */
export const WIDGETS = 'widgets';
export const CREATE_WIDGET = 'create-widget';
export const EDIT_WIDGET = 'edit-widget';

/**
 * Articles
 */
export const ARTICLES = 'articles';
export const EDIT_ARTICLE = 'edit-article';

/**
 * CONNECT
 */
export const CONNECT_SOCIAL_MEDIA = 'connect-social-media';
